import React, {useContext} from "react";
import {
  Button,
  Checkbox,
  Slider,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  setRef,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { useEffect, useState, useRef } from "react";
import { useLocalStorage } from "../utils/LocalStorageHook";
import TableAbstraction from "../componentUtils/TableAbstraction";
import { GetCus, GetGrouped, GetCusWithin } from "src/utils/GetGroup";
import { DisplayRoleContext } from "src/Context_api";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bankError: {
      padding: theme.spacing(2),
    },
    checkbox: {
      margin: 0,
      padding: 0,
    },
    slider: {
      width: "400px",
    },
    route: {
      padding: theme.spacing(2),
    },
    submit: {
      margin: theme.spacing(2),
    },
    bankTextField: {
      width: "200px",
    },
  })
);

interface ServicedGroupInput {
  customerNum: string;
  plant: string;
  postGroupChanges: any;
  groupedCustomer: any;
  setGroupedCustomer: any;
  isChanged: boolean;
  saveCustomerDetails: any;
  setWarningPopUp: any;
  setBackdropLoader: any;
  openGroupNameDialog: boolean;
  setOpenGroupNameDialog: any;
  isGroupCustomer:boolean;
}

export default function ServicedGroupPage(props: ServicedGroupInput) {
  const classes = useStyles();
  const {isDisplayOnlyRole}: any = useContext(DisplayRoleContext);
  const [miles, setMiles] = useState(0.25);
  const [changed, setChanged] = useState(true);
  const [state, setState] = useState<any>();
  const [rows, setRows] = useState<any>();
  const [groupInfo, setGroupInfo] = useState<any>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [selected, setSelected] = useState<any[]>([]);
  const [addedCus, setAddedCus] = useState<any[]>([]);
  const [groupName, setGroupName] = useState<string>("");
  const [searchCus, setSearchCus] = useState<string>("");
  const [groupUpdates, setGroupUpdates] = useState<any>();
  const [saveBtnVisible, setSaveBtnVisible] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>("");
  const [warningPop, setWarningPop] = useState<boolean>(false);
  const isGroupCustomer = props.isGroupCustomer
  const [snackBarStatus, setSnackBarStatus] = useState<any>({
    open: false,
    severity: 'success',
    message: ''
  });
  useEffect(() => {
    if (!changed) return;
    let _groupData:any
    if(isGroupCustomer){
    GetGrouped(salesOrg, props.customerNum)
      .then((v: any) => { 
        _groupData = v?.group?.mdServiceGroupedCustomer;
        const _cusArr:any[] = []
        _groupData?.map((item: any) => {
          _cusArr.push(item?.customerNum)
        })
        setGroupInfo(v) 
        GetCusWithin(salesOrg, props.customerNum, props.plant, miles, _cusArr)
        .then((v: any) => {
          setChanged(false);
          setState(v);
        })
        .catch((_) => setState([]))
      })
      .catch((_) => {
        setGroupInfo("Failed to find the group info")
        GetCusWithin(salesOrg, props.customerNum, props.plant, miles, [])
        .then((v: any) => {
          setChanged(false);
          setState(v);
        })
        .catch((_) => setState([]))
      });
    } else {
      setGroupInfo("Failed to find the group info")
        GetCusWithin(salesOrg, props.customerNum, props.plant, miles, [])
        .then((v: any) => {
          setChanged(false);
          setState(v);
        })
        .catch((_) => setState([]))
    }
  }, [state, miles]);
  const { groupedCustomer } = props
  useEffect(() => {
    if(state){
      const customerDetails = state?.filter((q: any) => props.groupedCustomer.includes(q.customer_num));
      props.saveCustomerDetails(customerDetails)
    }
  },[groupedCustomer])


  useEffect(() => {
    if(groupInfo && groupInfo.group && groupInfo.group.mdServiceGroupedCustomer){
      const groupCustArr: any[] = groupInfo.group.mdServiceGroupedCustomer.map((x: any) => x.customerNum);
      if(!groupCustArr.includes(props.customerNum)) {
        groupCustArr.unshift(props.customerNum);
        props.setGroupedCustomer(groupCustArr);
      } else {
        props.setGroupedCustomer(groupCustArr)
      }
    }else {
      const customerNum = [props.customerNum]
      props.setGroupedCustomer(customerNum)
    }
  }, [groupInfo])
  


  useEffect(() => {
    if (groupName === "") {
      setHelperText("Group name may not be empty.");
      setError(true);
    } else if (groupName?.length >= 0 && groupName?.length < 3) {
      setHelperText("Group name must be atleast 3 characters.");
      setError(true);
    } else if (groupName?.length > 20) {
      setHelperText("Group name should not exceed 20 characters.");
      setError(true);
    } else {
      setHelperText("");
      setError(false);
    }
  }, [groupName]);
  
  useEffect(()=> {
    if(addedCus?.length > 0 && state?.length > 0){
      // const newArr = rows.concat(state)
      const removeDuplicates = [...new Set([...addedCus,...rows,...state])]
      // removeDuplicates.unshift()
      setRows(removeDuplicates)
    }else if(state?.length > 0){
      setRows(state)
    }
  },[addedCus, state])

  useEffect(()=> { 
    //console.log(rows)
  }, [rows])

  if (!state || typeof state === "string") return <Typography className={classes.bankError}>{state}</Typography>;

  const getCus = () => {
    setSearchCus("")
    if(searchCus){
      const cusArr = rows?.map((item:any) => item?.customer_num)
      if(cusArr.indexOf(searchCus) >= 0){
        setSnackBarStatus({...snackBarStatus, open:true, severity: 'warning', message:'Customer already exists'})
      }else{
        props.setBackdropLoader(true)
        GetCus(salesOrg,props.customerNum, props.plant, searchCus)
        .then((v:any) => {
          props.setBackdropLoader(false)
          // let newAddedCus: any[] = addedCus
          // newAddedCus.push(v[0]);
          if(v?.length > 0){
            setAddedCus(v)
            setSnackBarStatus({...snackBarStatus, open:true, severity: 'success', message:'Customer added successfully'})
          }else {
            setSnackBarStatus({...snackBarStatus, open:true, severity: 'error', message:'Failed to add customer'})
          }
         // console.log("🚀 ~ file: ServicedGroup.tsx:132 ~ .then ~ v", v)
        })
        .catch((e:any) => {
          props.setBackdropLoader(false)
          setSnackBarStatus({...snackBarStatus, open:true, severity: 'error', message:'Failed to add customer'})

        })
      }
     
    }
  }
  
  const handleSubmit = () => {
    if (props.groupedCustomer?.length === 0) {
      props.setWarningPopUp(true);
    }
    else {
      const selectedCus = rows.filter((q: any) => props.groupedCustomer.includes(q.customer_num));
      let guid = "";
      let name = "";

      if (groupInfo && groupInfo.group) {
        guid = groupInfo.group.guid;
        name = groupInfo.group.groupName;
      }
      const obj: any = {
        clientId: "100",
        salesOrg,
        salesOffice: selectedCus[0].sales_office,
        plant:selectedCus[0].delivering_plant,
        groupName: groupName || name,
        mdServiceGroupedCustomer: selectedCus.map((c: any) => ({
          ...c,
          salesOffice: c.sales_office,
          customerNum: c.customer_num,
        })),
      };
      if (guid) obj.guid = guid;
      const groupUpdate = obj;
      if (selectedCus.length >= 2) {
        if (obj.groupName === "") {
          setGroupUpdates(obj);
          props.setOpenGroupNameDialog(true);
        } else {
          props.postGroupChanges(salesOrg, groupUpdate);
        }
      } else {
        setWarningPop(true);
      }

    }
  };

  const handleCheckbox = (value: string) => {
    if (value != props.customerNum) {
      // if (props.groupedCustomer.indexOf(value) === -1) {
      //   const newBankedCust: Array<string> = props.groupedCustomer;
      //   newBankedCust.push(value);
      //   props.setGroupedCustomer(newBankedCust);
      // } else {
      //   const newBankedCust: Array<string> = props.groupedCustomer.filter((val: string) => val !== value);
      //   props.setGroupedCustomer(newBankedCust);
      // }
      //setSaveBtnVisible(true);
      let newGroupedCustomer: Array<string> = [...props.groupedCustomer];
    if (newGroupedCustomer.includes(value)) {
      newGroupedCustomer = newGroupedCustomer.filter((val: string) => val !== value);
    } else {
      newGroupedCustomer.push(value);
    }
    props.setGroupedCustomer(newGroupedCustomer);
    setSaveBtnVisible(true);
    }
  };

  const handleGroupNameSave = () => {
    if(groupUpdates){
      groupUpdates.groupName = groupName
      props.setOpenGroupNameDialog(false)
      props.setBackdropLoader(true)
      props.postGroupChanges(groupUpdates.salesOrg, groupUpdates)
    } else {
      const selectedCus = state.filter((q: any) => props.groupedCustomer.includes(q.customer_num));
      let guid = ""
      let name = "";

      if (groupInfo && groupInfo.group) {
        guid = groupInfo.group.guid;
        name = groupInfo.group.group_name;
      }
      const obj: any = {
        clientId: "100",
        salesOrg,
        salesOffice: selectedCus[0].sales_office,
        plant:selectedCus[0].delivering_plant,
        groupName: groupName || name,
        mdServiceGroupedCustomer: selectedCus.map((c: any) => ({
          ...c,
          salesOffice: c.sales_office,
          customerNum: c.customer_num,
        })),
      };
      if (guid) obj.guid = guid;
      props.postGroupChanges(salesOrg, obj);


    }
  }
  const vertical = 'top'
  const horizontal = 'right'


  return (
    <div className={classes?.route}>
      {props.groupedCustomer.length < 1 && (
        <Typography>Warning: No Grouped customers found. You may create a new one.</Typography>
      )}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={snackBarStatus?.open}
        autoHideDuration={6000}
        onClose={() => setSnackBarStatus({...snackBarStatus, open:false})}
        key={vertical + horizontal}
      >
        <Alert  severity={snackBarStatus.severity} sx={{ width: '100%', marginTop: '25%' }}>
          {snackBarStatus?.message}
        </Alert>
      </Snackbar>
      {isGroupCustomer ?  '' : <Alert>Customer is not associated with any service Group </Alert>}
      <Grid container spacing={2} justifyContent="space-between">
        <Grid item xs={6}>
          <Typography id="discrete-slider-small-steps" gutterBottom>
            Distance ({miles} Miles)
          </Typography>
          <div className={classes.slider}>
            <Slider
              defaultValue={1}
              aria-labelledby="discrete-slider-small-steps"
              step={0.25}
              marks
              min={0.25}
              max={10}
              value={miles}
              onChange={(_, value) => {
                if (value == miles) return;
                setChanged(true);
                setMiles(value as number);
              }}
              onChangeCommitted={(_, value) => {
                setChanged(true);
                setMiles(value as number);
              }}
              valueLabelDisplay="auto"
            />
          </div>
        </Grid>
        <Grid item xs={6}>
        <TextField id="outlined-basic" label="Search Customer" variant="outlined" placeholder="Enter Customer Number" value={searchCus} onChange={(e) => setSearchCus(e.target.value)}/>
        <Button variant="contained" onClick={getCus} disabled={!searchCus}>Add Customer</Button>
        </Grid>
      </Grid>
      

      {
        <Dialog
          fullWidth
          maxWidth="sm"
          open={props.openGroupNameDialog}
          // onClose={handleBankNameDialogClose}
        >
          <DialogContent>
            <TextField
              className={classes.bankTextField}
              autoFocus
              margin="dense"
              id="name"
              label="Service Group Name"
              type="text"
              fullWidth
              value={groupName}
              onChange={(v: any) => setGroupName(v.target.value)}
              variant="standard"
              placeholder="Please enter the Group Name"
              helperText={helperText}
              error={error}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setGroupName("");
                props.setOpenGroupNameDialog(false);
              }}
            >
              Cancel
            </Button>
            <Button disabled={error} onClick={handleGroupNameSave}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      }

      <TableAbstraction
        settingsKey="SRVC_GRP"
        title="Nearby Customers"
        options={{
          elevation: 0,
          draggableColumns: {
            enabled: true,
          },
          selectableRows: "multiple",
          onRowSelectionChange: (currentRows, allRows) => {
            setSelected(allRows);
          },
          //   rowsPerPage: 25,
          //   rowsPerPageOptions: [25, 50, 100],
        }}
        columns={[
          {
            label: "Customer No",
            name: "custNo",
            options:{
              searchable: true
            }
          },
          {
            label: "Customer Name",
            name: "name1",
          },
          {
            label: "Location",
            name: "location",
            options: {
              renderCell: (params) => {
                const obj = params.row;
                return [obj.street, obj.city, obj.state].filter((v: string) => v.length > 0).join(", ");
              },
            },
          },

          {
            label: "Route",
            name: "master_route",
          },
          {
            label: "Delivery Plant",
            name: "delivering_plant",
          },
          {
            label: "Distance",
            name: "distance",
            options: {
              customBodyRender: (value, tableMeta) => value && (value as number).toFixed(2) + " miles",
            },
          },
          {
            label: "Active",
            name: "active",
          },
          {
            label: "Grouped",
            name: "",
            valueGetter: (params) => (props.groupedCustomer.length > 0 && props.groupedCustomer.indexOf(params.row.customer_num) !== -1),
            options: {
              renderCell: (params: any) => {
                const item = params.row;
                return (<Checkbox disabled={isDisplayOnlyRole}
                  checked={props.groupedCustomer.length > 0 && props.groupedCustomer.indexOf(item.customer_num) !== -1}
                  name="active"
                  color="primary"
                  className={classes.checkbox}
                  onChange={() => handleCheckbox(item.customer_num)}
                />);
              },
            },
          },
        ]}
        data={rows}
        handleSaveProps={{ handleSave: handleSubmit, visible: saveBtnVisible || props.isChanged, isDisplayOnlyRole }}
      />
       <Dialog open={warningPop} onClose={() => setWarningPop(false)}>
        <DialogTitle>Please include at least two customers when creating the group.</DialogTitle>
        <DialogActions>
          <Button
            onClick={() => {
              setWarningPop(false);
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
